import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { Inspection } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './machineselector.component.html',
    standalone: false
})
export class MachineSelectorPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;
  public machine: any;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.machine =
      this.inspection.data != null && this.inspection.data.machine != null ? this.inspection.data.machine : null;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'machineselector',
      'edit'
    ];
  }
}

PluginComponent.plugins['machineselector'] = MachineSelectorPluginComponent;
